import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import adminDe from "../locales/de/admin.json";
import authDe from "../locales/de/auth.json";
import commonDe from "../locales/de/common.json";
import legalDe from "../locales/de/legal.json";
import orderingDe from "../locales/de/ordering.json";
import ordersDe from "../locales/de/orders.json";
import profileDe from "../locales/de/profile.json";
import supportDe from "../locales/de/support.json";
import adminEn from "../locales/en/admin.json";
import authEn from "../locales/en/auth.json";
import commonEn from "../locales/en/common.json";
import legalEn from "../locales/en/legal.json";
import orderingEn from "../locales/en/ordering.json";
import ordersEn from "../locales/en/orders.json";
import profileEn from "../locales/en/profile.json";
import supportEn from "../locales/en/support.json";

const mergeTranslations = (
	...translationObjects: Record<string, unknown>[]
): Record<string, unknown> => {
	return Object.assign({}, ...translationObjects);
};

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: {
				translation: mergeTranslations(
					commonEn,
					authEn,
					profileEn,
					orderingEn,
					ordersEn,
					adminEn,
					supportEn,
					legalEn,
				),
			},
			de: {
				translation: mergeTranslations(
					commonDe,
					authDe,
					profileDe,
					orderingDe,
					ordersDe,
					adminDe,
					supportDe,
					legalDe,
				),
			},
		},
		defaultNS: "translation",
		ns: ["translation"],
		fallbackLng: "de",
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
		detection: {
			order: ["localStorage"],
			caches: ["localStorage"],
		},
	});

export default i18n;
